import { render, staticRenderFns } from "./uEditor.vue?vue&type=template&id=f2788b62&scoped=true&"
import script from "./uEditor.vue?vue&type=script&lang=js&"
export * from "./uEditor.vue?vue&type=script&lang=js&"
import style0 from "./uEditor.vue?vue&type=style&index=0&id=f2788b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2788b62",
  null
  
)

export default component.exports